// src/pages/SubscriptionPage.js
import { useState, useEffect } from 'react'
//import { useLocation, useNavigate } from 'react-router-dom';

function SubscriptionPage() {
  //    const { user, loading: authLoading } = useAuth();
  const user = { id: 1, name: 'AAA' }
  const [subscriptionInfo] = useState(null)
  // Removed: plans and selectedPriceId states are no longer needed for initial display/selection
  const [error, setError] = useState(null)
  const [processing, setProcessing] = useState(false) // Used for actions like force refresh, or portal redirect
  //const [loadingSubscription, setLoadingSubscription] = useState(true);
  // Removed: loadingPlans state as we're not fetching plans manually anymore
  const [successMessage, setSuccessMessage] = useState(null)

  //const location = useLocation();
  //const navigate = useNavigate();

  // IMPORTANT: Replace 'YOUR_PRICING_TABLE_ID' with the actual ID of your Stripe Pricing Table
  // You can find this in your Stripe Dashboard under Products -> Pricing Tables.
  // Also, ensure 'pk_test_YOUR_PUBLISHABLE_KEY' is your actual Stripe Publishable Key.
  const STRIPE_PRICING_TABLE_ID = 'prctbl_1Rc3Ee4WcOErFt5KcfA6r3AF' // e.g., 'prctbl_12345...'
  const STRIPE_PUBLISHABLE_KEY =
    'pk_test_51Rc1H04WcOErFt5KQDbFpb5DaTxqjLAycA49Mdj5IGKyCTWXVnU5OlU6Fe1eE0rSIAValx4CZl5CBbBRYm3NtQij00ZTehGTmm' // e.g., 'pk_test_abC123...'

  // /**
  //  * Handles redirects from Stripe Checkout/Customer Portal.
  //  */
  // useEffect(() => {
  //     const queryParams = new URLSearchParams(location.search);
  //     const status = queryParams.get('status');
  //     const sessionId = queryParams.get('session_id'); // From Checkout success_url
  //
  //     if (status === 'success' && sessionId) {
  //         setSuccessMessage('Subscription process completed successfully! Your plan details will update shortly.');
  //         navigate(location.pathname, { replace: true }); // Clear query params
  //         fetchSubscription(true); // Force refresh cache after successful Checkout
  //     } else if (status === 'canceled') {
  //         setError('Subscription process was canceled or failed.');
  //         navigate(location.pathname, { replace: true }); // Clear query params
  //         fetchSubscription(true); // Refresh in case of cancellation
  //     }
  // }, [location, navigate]);

  // /**
  //  * Fetches the authenticated user's current subscription details from the backend.
  //  * Optionally forces a cache refresh on the backend.
  //  * @param {boolean} refreshCache - Whether to force the backend to refresh its cache.
  //  */
  // const fetchSubscription = useCallback(async (refreshCache = false) => {
  //     if (!user) {
  //         setLoadingSubscription(false);
  //         return;
  //     }
  //     setLoadingSubscription(true);
  //     try {
  //         const response = await axios.get(`/subscription${refreshCache ? '?refresh_cache=true' : ''}`);
  //         setSubscriptionInfo(response.data);
  //     } catch (error) {
  //         console.error('Error fetching subscription:', error);
  //         setError(error.response?.data?.message || 'Failed to load subscription information.');
  //         setSubscriptionInfo(null);
  //     } finally {
  //         setLoadingSubscription(false);
  //     }
  // }, [user]);

  // // Effect to fetch initial subscription data on component mount or user change
  // useEffect(() => {
  //     if (!authLoading && user) {
  //         fetchSubscription();
  //         // Removed fetchPlans() as we are now using Stripe Pricing Table
  //     }
  // }, [user, authLoading, fetchSubscription]);

  // Effect to load and render Stripe Pricing Table
  useEffect(() => {
    // Only load if the pricing table ID is set and user is not subscribed
    if (
      !subscriptionInfo?.has_active_subscription &&
      STRIPE_PRICING_TABLE_ID &&
      STRIPE_PUBLISHABLE_KEY
    ) {
      const scriptId = 'stripe-pricing-table-script'
      if (!document.getElementById(scriptId)) {
        const script = document.createElement('script')
        script.id = scriptId
        script.src = 'https://js.stripe.com/v3/pricing-table.js'
        script.async = true
        script.onload = () => {
          // Once the script is loaded, you can confirm pricing table is ready.
          console.log('Stripe Pricing Table script loaded.')
          // The pricing-table component will automatically render into the <stripe-pricing-table> tag.
        }
        document.body.appendChild(script)
      }
    }
  }, [subscriptionInfo, STRIPE_PRICING_TABLE_ID, STRIPE_PUBLISHABLE_KEY])

  /**
   * Initiates the Stripe Customer Portal process by getting a session URL from the backend
   * and redirecting the user.
   */
  const handleManageSubscriptionInPortal = async () => {
    setProcessing(true)
    setError(null)
    setSuccessMessage(null)

    // try {
    //     // Call backend to create a Customer Portal Session
    //     const response = await axios.post('/create-customer-portal-session');
    //
    //     // Redirect the user to the Stripe Customer Portal
    //     if (response.data.url) {
    //         window.location.href = response.data.url;
    //     } else {
    //         setError('Failed to get Stripe Customer Portal URL.');
    //     }
    // } catch (err) {
    //     setError(err.response?.data?.error || 'An unexpected error occurred while accessing billing portal.');
    //     console.error('Customer Portal initiation error:', err);
    // } finally {
    //     setProcessing(false);
    // }
  }

  /**
   * Function to explicitly force a refresh of subscription data from the backend.
   */
  const forceRefreshSubscriptionData = () => {
    //     fetchSubscription(true);
  }
  //
  // if (authLoading || loadingSubscription) { // Removed loadingPlans
  //     return <div style={{ textAlign: 'center', padding: '20px' }}>Loading subscription data...</div>;
  // }

  return (
    <div
      style={{
        maxWidth: '800px',
        margin: '20px auto',
        padding: '25px',
        border: '1px solid #e0e0e0',
        borderRadius: '10px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      }}
    >
      <h2 style={{ textAlign: 'center', color: '#333', marginBottom: '30px' }}>
        Subscription Management
      </h2>

      <button
        onClick={forceRefreshSubscriptionData}
        disabled={processing}
        style={{
          padding: '10px 20px',
          backgroundColor: '#6c757d',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '14px',
          marginBottom: '20px',
          float: 'right',
        }}
      >
        {processing ? 'Refreshing...' : 'Force Refresh Data'}
      </button>
      <div style={{ clear: 'both' }}></div>

      {error && (
        <div
          style={{
            color: '#dc3545',
            backgroundColor: '#f8d7da',
            border: '1px solid #f5c6cb',
            borderRadius: '5px',
            padding: '10px',
            marginBottom: '20px',
          }}
        >
          Error: {error}
        </div>
      )}
      {successMessage && (
        <div
          style={{
            color: '#28a745',
            backgroundColor: '#d4edda',
            border: '1px solid #c3e6cb',
            borderRadius: '5px',
            padding: '10px',
            marginBottom: '20px',
          }}
        >
          {successMessage}
        </div>
      )}

      {subscriptionInfo?.has_active_subscription ? (
        <div>
          <h3 style={{ color: '#007bff', marginBottom: '15px' }}>
            Your Current Plan:
          </h3>
          <div
            style={{
              backgroundColor: '#f8f9fa',
              padding: '20px',
              borderRadius: '8px',
              marginBottom: '30px',
              border: '1px solid #e9ecef',
            }}
          >
            <p style={{ margin: '5px 0' }}>
              <strong>Plan Name:</strong>{' '}
              {subscriptionInfo.subscription.plan_name}
            </p>
            <p style={{ margin: '5px 0' }}>
              <strong>Status:</strong>{' '}
              <span
                style={{
                  textTransform: 'capitalize',
                  fontWeight: 'bold',
                  color:
                    subscriptionInfo.subscription.status === 'active'
                      ? '#28a745'
                      : '#ffc107',
                }}
              >
                {subscriptionInfo.subscription.status.replace('_', ' ')}
              </span>
            </p>
            {subscriptionInfo.subscription.is_trialing && (
              <p style={{ margin: '5px 0' }}>
                <strong>Trial Ends:</strong>{' '}
                {new Date(
                  subscriptionInfo.subscription.trial_ends_at,
                ).toLocaleDateString()}
              </p>
            )}
            <p style={{ margin: '5px 0' }}>
              <strong>Current Period Ends:</strong>{' '}
              {subscriptionInfo.subscription.current_period_end
                ? new Date(
                    subscriptionInfo.subscription.current_period_end,
                  ).toLocaleDateString()
                : 'N/A'}
            </p>
          </div>

          <h4 style={{ color: '#333', marginBottom: '15px' }}>
            Features Included:
          </h4>
          <ul
            style={{
              listStyleType: 'none',
              padding: 0,
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '10px',
              marginBottom: '30px',
            }}
          >
            {Object.entries(subscriptionInfo.features).map(
              ([featureName, featureValue]) => (
                <li
                  key={featureName}
                  style={{
                    backgroundColor: '#e9f7ef',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #c6ead7',
                  }}
                >
                  <strong>
                    {featureName
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, (char) => char.toUpperCase())}
                    :
                  </strong>{' '}
                  {featureValue === true ? 'Enabled' : featureValue}
                </li>
              ),
            )}
          </ul>

          <hr style={{ margin: '40px 0' }} />

          <h3 style={{ color: '#007bff', marginBottom: '20px' }}>
            Manage Your Subscription:
          </h3>
          <p style={{ marginBottom: '15px', color: '#555' }}>
            Click the button below to manage your plan, update payment methods,
            and view billing history on Stripe&apos;s secure Customer Portal.
          </p>
          <button
            onClick={handleManageSubscriptionInPortal}
            disabled={processing}
            style={{
              padding: '12px 25px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold',
              transition: 'background-color 0.3s ease',
            }}
          >
            {processing ? 'Loading Portal...' : 'Go to Billing Portal'}
          </button>
        </div>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <h3 style={{ color: '#007bff', marginBottom: '20px' }}>
            Start Your Subscription:
          </h3>
          <p style={{ color: '#666', marginBottom: '30px' }}>
            Choose a plan that fits your needs. You will be redirected to
            Stripe&apos;s secure checkout page.
          </p>
          {/* Stripe Pricing Table will render here */}
          <stripe-pricing-table
            pricing-table-id={STRIPE_PRICING_TABLE_ID}
            publishable-key={STRIPE_PUBLISHABLE_KEY}
            customer-session-client-reference-id={user?.id} // Pass user ID as client reference ID
          ></stripe-pricing-table>
        </div>
      )}
    </div>
  )
}

export default SubscriptionPage
